module.exports = __webpack_public_path__ + "front/img/2.2c79e982.png";